export function hasWebGL(): boolean {
  try {
    const canvas = document.createElement('canvas')
    return !!(
      (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')) &&
      window.WebGLRenderingContext
    )
  } catch {
    return false
  }
}

export function prefersReducedMotion(): boolean {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
